/* istanbul ignore file */
import { action, observable, computed } from 'mobx';
import { memoize } from 'lodash';
import Files from './files';

export default class Uploader {
  @observable uploadList = [];

  constructor(settingsStore, request) {
    this.settingsStore = settingsStore;
    this.request = request;
  }

  transformFiles = memoize(
    f => new Files(this.settingsStore, this.request, f),
    f => f.id
  );

  @action
  removeAllFiles() {
    if (this.uploads[0]) {
      this.uploads[0].fileList.clear();
    }
  }

  @action
  createFiles(uploadInfo) {
    this.uploadList.push(uploadInfo);
  }

  @computed
  get uploads() {
    return this.uploadList.map(f => this.transformFiles(f));
  }

  @action getFiles = fid => this.uploads.find(f => f.data.id === fid);
}



// WEBPACK FOOTER //
// ./src/stores/uploader.js